import { describeDomains, noArgsSchema } from "../operation-meta.js";
import { appSettingByKeyQueryArgsSchema, personIDQueryArgsSchema, } from "../projects-input-schemas.js";
export function createAdminDataQueries({ defineProjectQuery, projectZql, }) {
    if (!defineProjectQuery) {
        throw new Error("Missing admin data query dependencies");
    }
    return {
        appSettings: {
            byKey: defineProjectQuery(appSettingByKeyQueryArgsSchema, ({ args, ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.appSettings
                        .where("key", "__unauthorized__")
                        .one();
                }
                return projectZql.appSettings.where("key", args.key).one();
            }),
        },
        allergyTags: {
            list: defineProjectQuery(noArgsSchema, ({ ctx }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.allergyTags.where("id", "__unauthorized__");
                }
                return projectZql.allergyTags.orderBy("name", "asc");
            }),
        },
        personAllergyTags: {
            byPerson: defineProjectQuery(personIDQueryArgsSchema, ({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.personAllergyTags.where("id", "__unauthorized__");
                }
                return projectZql.personAllergyTags
                    .where("personID", args.personID)
                    .related("allergyTag");
            }),
        },
    };
}
export function createAdminDataMutators({ defineProjectMutator, projectZql, schemas, assertAdminDataWriteAccess, replacePersonAllergyTags, }) {
    if (!defineProjectMutator ||
        !schemas ||
        !assertAdminDataWriteAccess ||
        !replacePersonAllergyTags) {
        throw new Error("Missing admin data mutator dependencies");
    }
    return {
        appSettings: {
            update: defineProjectMutator(schemas.updateAppSettingInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                const existing = await tx.run(projectZql.appSettings.where("key", args.key).one());
                if (existing) {
                    await tx.mutate.appSettings.update({
                        key: args.key,
                        value: args.value,
                        updatedAt: Date.now(),
                    });
                }
                else {
                    await tx.mutate.appSettings.insert({
                        key: args.key,
                        value: args.value,
                        updatedAt: Date.now(),
                    });
                }
            }),
        },
        allergyTags: {
            create: defineProjectMutator(schemas.createAllergyTagInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.allergyTags.insert(args);
            }),
        },
        personAllergyTags: {
            set: defineProjectMutator(schemas.setPersonAllergyTagsInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await replacePersonAllergyTags(tx, args.personID, args.tagIDs);
            }),
        },
    };
}
export const adminDataDomainDescriptions = describeDomains({
    allergyTags: "Allergy and dietary tags that can be assigned to people",
    appSettings: "Global app settings (key/value), admin only",
    personAllergyTags: "Which allergy tags are assigned to which person",
});
